/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_DescInputs */



/**
* | output |
* | --- |
* | "Speaker-identified DOCX/CSV" |
*
* @param {File_Export_Dialogue_List_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_desc = /** @type {((inputs?: File_Export_Dialogue_List_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("DOCX/CSV avec identification des intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecheridentifiziertes DOCX/CSV")
	if (locale === "it") return /** @type {LocalizedString} */ ("DOCX/CSV identificato dall'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("DOCX/CSV, идентифицированный говорящим")
	if (locale === "es") return /** @type {LocalizedString} */ ("DOCX/CSV identificado por el hablante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已识别说话人的 DOCX/CSV")
	if (locale === "ja") return /** @type {LocalizedString} */ ("話者識別DOCX/CSV")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता द्वारा पहचाने गए DOCX/CSV")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("DOCX/CSV com identificação do orador")
	return /** @type {LocalizedString} */ ("Speaker-identified DOCX/CSV")
});